/**
 * Calculate finance commission flat amount from percentage
 * @param fundedAmount - The funded amount
 * @param financeCommissionPercent - The commission percentage
 * @returns The calculated commission flat amount rounded to 2 decimal places
 */
export function calculateCommissionFlat(fundedAmount: number, financeCommissionPercent: number): number {
  return +((fundedAmount * financeCommissionPercent) / 100).toFixed(2);
}

/**
 * Calculate finance commission percentage from flat amount
 * @param fundedAmount - The funded amount
 * @param financeCommissionFlat - The commission flat amount
 * @returns The calculated commission percentage rounded to 2 decimal places
 */
export function calculateCommissionPercent(fundedAmount: number, financeCommissionFlat: number): number {
  return +((financeCommissionFlat / fundedAmount) * 100).toFixed(2);
}
